import { Box, BoxExtendedProps } from 'grommet'
import { Checkmark, Close } from 'grommet-icons'
import { ReactNode } from 'react'
import { Button } from '../Button'

type Props = {
  onClose: () => void
  isLoading?: boolean
  submit?: string
  cancel?: string
  type?: 'submit' | 'button' | 'reset' | undefined
  onClick?: () => void
  disabled?: boolean
  form?: string
  leftIcon?: JSX.Element
  rightIcon?: JSX.Element
  cancleIcon?: boolean
  calcelRightIcon?: boolean
  justify?: 'start' | 'end' | 'between' | 'around' | 'center' | 'evenly' | 'stretch'
  addon?: ReactNode
  secondaryActions?: ReactNode
} & BoxExtendedProps

export const FormButton = ({
  onClose,
  isLoading,
  cancel,
  submit,
  type = 'submit',
  onClick,
  disabled,
  form,
  justify = 'end',
  cancleIcon = true,
  calcelRightIcon = false,
  leftIcon,
  rightIcon,
  addon,
  secondaryActions,
  ...rest
}: Props) => {
  const submitButton = (
    <Button
      className="capitalize"
      disabled={disabled || isLoading}
      form={form}
      icon={calcelRightIcon ? undefined : rightIcon || <Checkmark color="white" size="small" />}
      isLoading={isLoading}
      label={submit || 'Add'}
      onClick={onClick}
      type={type}
    />
  )
  return (
    <Box
      align="center"
      as="footer"
      border={{ side: 'top', size: 'xsmall' }}
      direction="row"
      flex={false}
      gap={'8px'}
      justify={justify}
      pad={{ horizontal: '32px', vertical: '14px' }}
      style={{ background: '#fff', position: 'relative', zIndex: 10 }}
      width="100%"
      {...rest}
    >
      {addon}
      <Button
        className="capitalize"
        disabled={isLoading}
        icon={leftIcon ? leftIcon : cancleIcon ? <Close color="black" size="small" /> : undefined}
        kinds={'secondary'}
        label={cancel || 'Cancel'}
        onClick={onClose}
        type="button"
      />
      {secondaryActions ? (
        <Box align="center" direction="row" gap="8px" justify="end" wrap>
          {secondaryActions}
          {submitButton}
        </Box>
      ) : (
        submitButton
      )}
    </Box>
  )
}
